import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-tick-01',
  standalone: true,
  templateUrl: '../../assets/tick-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamTick01Icon {}
